import { useCallback } from 'react';
import { api as rawApi, ApiError } from './client';
import { useAuth } from './AuthContext';

export function useApi() {
  const { getIdToken, signOut } = useAuth();

  return useCallback(async function call<T = unknown>(
    path: string,
    init: { method?: string; body?: unknown } = {}
  ): Promise<T> {
    const token = await getIdToken();
    if (!token) {
      await signOut();
      throw new ApiError(401, 'not_authenticated');
    }
    return rawApi<T>(path, { ...init, token });
  }, [getIdToken, signOut]);
}
